module.exports = __webpack_public_path__ + "static/media/conversations.fcd0300a.svg";